const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/

export function formatDate(iso: string): string {
  // A bare YYYY-MM-DD parses as UTC midnight, which toLocaleDateString then
  // shifts back a day for negative-UTC offsets. Append local midnight so the
  // calendar day renders as written.
  const date = DATE_ONLY.test(iso) ? new Date(`${iso}T00:00:00`) : new Date(iso)
  if (Number.isNaN(date.getTime())) {
    return iso
  }
  return date.toLocaleDateString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  })
}

export function formatTime(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) {
    return iso
  }
  return date.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })
}

export function formatDuration(startIso: string, endIso: string): string {
  const start = new Date(startIso).getTime()
  const end = new Date(endIso).getTime()
  if (Number.isNaN(start) || Number.isNaN(end)) {
    return ""
  }
  const minutes = Math.max(0, Math.round((end - start) / 60000))
  return `${minutes} min`
}

export function formatAnswerValue(value: unknown): string {
  if (value === null || value === undefined) {
    return "—"
  }
  if (Array.isArray(value)) {
    return value.length ? value.map((item) => String(item)).join(", ") : "—"
  }
  if (typeof value === "object") {
    return JSON.stringify(value)
  }
  return String(value)
}

const SNIPPET_MAX = 140

export function snippet(text: string): string {
  const collapsed = text.replace(/\s+/g, " ").trim()
  const chars = [...collapsed]
  return chars.length > SNIPPET_MAX ? `${chars.slice(0, SNIPPET_MAX - 1).join("")}…` : collapsed
}
